import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "slack",
  "use": "slack-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"slack\"><path d=\"M12.5 1A1.5 1.5 0 0 1 14 2.5v5a1.5 1.5 0 0 1-3 0v-5A1.5 1.5 0 0 1 12.5 1Zm-10 10H4v1.5A1.5 1.5 0 1 1 2.5 11Zm8.5 5h1.5a1.5 1.5 0 1 1-1.5 1.5V16Zm1.5-5h5a1.5 1.5 0 0 1 0 3h-5a1.5 1.5 0 0 1 0-3Zm5-5a1.5 1.5 0 0 1 0 3H16V7.5A1.5 1.5 0 0 1 17.5 6Zm-15 0h5a1.5 1.5 0 0 1 0 3h-5a1.5 1.5 0 0 1 0-3Zm5-5A1.5 1.5 0 0 1 9 2.5V4H7.5a1.5 1.5 0 0 1 0-3Zm0 10A1.5 1.5 0 0 1 9 12.5v5a1.5 1.5 0 0 1-3 0v-5A1.5 1.5 0 0 1 7.5 11Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol